// extracted by mini-css-extract-plugin
export var block = "notification-module--block--b72e6";
export var button = "notification-module--button--8487a";
export var buttonWrapper = "notification-module--buttonWrapper--ada64";
export var text = "notification-module--text--25063";
export var textWrapper = "notification-module--textWrapper--3ec67";
export var wrapper = "notification-module--wrapper--e88be";